import { FunctionComponent } from 'react';
import { ReactComponent as TrashIconSVG } from '../../assets/icons/mevo/ic_trash_striped.svg';
import IconPattern, { IconProps } from './_IconPattern';

const TrashStripedIcon: FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={TrashIconSVG} variantPlaces={[]} {...props} />;
};

export default TrashStripedIcon;
